import { ItemLabelDecorator } from "../../../../gui/Common.js";
import { IconName, getIconSVG } from "../../../../gui/IconSVG.js";
import { PARTHENOPE_GLOBAL_CSS_PREFIX } from "../../ParthenopeGUIV2.js";

export class ControlButton {

    private mainHtml: HTMLElement;
    private currentIcon: HTMLElement;

    constructor(icon: IconName, private decorator?: ItemLabelDecorator) {
        const bClass = `${PARTHENOPE_GLOBAL_CSS_PREFIX}-btn`;
        this.currentIcon = getIconSVG(icon);
        this.mainHtml = <div class={`${bClass} ${bClass}--${icon}`}>
            {this.currentIcon}
        </div>;
    }

    get html(): HTMLElement {
        return this.mainHtml;
    }
    
    setDecorator(decorator?: ItemLabelDecorator) {
        if (this.decorator) this.mainHtml.classList.remove(this.decorator);
        if (decorator) {
            this.decorator = decorator;
            this.mainHtml.classList.add(this.decorator);
        }
    }

    changeIcon(icon: IconName) {
        this.currentIcon.remove();
        const newIcon = getIconSVG(icon)
        this.mainHtml.appendChild(newIcon);
        this.currentIcon = newIcon;
    }


    updateStatus(enabled: boolean) {
        if (enabled) {
            this.mainHtml.classList.remove('disabled')
        } else {
            this.mainHtml.classList.add('disabled');
        }
    }

    onClick(listener: EventListener): void {
        this.mainHtml.addEventListener("click", listener);
    }

}